import type { TUser, UserRole } from "./types";

export type { UserRole } from "./types";
export * from "./types";

export const ERoleAccess = {
  CLIENT_USER: "clientUser" as const,
  CLIENT_ADMIN: "clientAdmin" as const,
  SYSTEM_ADMIN: "systemAdmin" as const
} as const;

export type ERoleAccessType = (typeof ERoleAccess)[keyof typeof ERoleAccess];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const hasAdminPrivileges = (user: TUser): boolean => {
  return user.role === "clientAdmin" || user.role === "systemAdmin";
};

export const canManageOrganization = (user: TUser, targetOrgId: number): boolean => {
  if (user.role === "systemAdmin") {
    return true;
  }

  if (user.role === "clientAdmin") {
    return user.organizationId === targetOrgId;
  }

  return false;
};

export const getTargetOrganizationId = (user: TUser, requestedOrgId?: number): number => {
  if (user.role === "systemAdmin" && requestedOrgId !== undefined) {
    return requestedOrgId;
  }
  return user.organizationId;
};

export const hasOrganizationAccess = (user: TUser, targetOrgId: number): boolean => {
  return user.role === "systemAdmin" || user.organizationId === targetOrgId;
};

export const isSystemAdmin = (user: TUser): boolean => {
  return user.role == "systemAdmin";
};
